<div *ngFor="let section of menuPoints.sections; index as index" class="menu-box">
  <mat-expansion-panel
    #expPanels
    (opened)="setOpenedPanel(index)"
    *ngIf="isSectionVisible(section)"
    [expanded]="isExpanded(index)"
    class="exp-panel--sidebar"
    hideToggle>
    <mat-expansion-panel-header
      class="panel-header"
      collapsedHeight="48px"
      expandedHeight="48px"
      [attr.data-test]="section.testId"
      [class.ff-debug]="ffDebug"
      [attr.data-ff-id]="ffDebug ? section.growthbookFlagId : null"
      [attr.title]="ffDebug ? 'GrowthBook: ' + section.growthbookFlagId : null">
      <mat-panel-title
        [matTooltipPosition]="'right'"
        [matTooltip]="menuCollapsed ? (section.name | translate) : undefined"
        class="question-title">
        <a
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLink]="section.route"
          class="title-box"
          routerLinkActive="title-box--active-link">
          <div class="item-with-icon">
            <eop-icon
              [vaylensFont]="true"
              [clickable]="true"
              [color]="IconColor.INHERIT"
              [identifier]="section.icon"></eop-icon>
            <span *ngIf="!menuCollapsed" class="link-text--expanded body-l">
              {{ section.name | translate }}
            </span>
          </div>
        </a>
      </mat-panel-title>

      <mat-panel-description *ngIf="!menuCollapsed" class="expand-arrows link-text--expanded-flex">
        <eop-icon
          [identifier]="
            expPanels.expanded ? 'small-chevron-up-outlined' : 'small-chevron-down-outlined'
          "
          [vaylensFont]="true"></eop-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ul class="on-card-box-shadow--inset">
      <ng-container *ngFor="let link of section.links">
        <li
          *ngIf="isVisible(link)"
          [class.ff-debug]="ffDebug"
          [attr.data-ff-id]="ffDebug ? link.growthbookFlagId : null"
          [attr.title]="ffDebug ? 'GrowthBook: ' + link.growthbookFlagId : null">
          <eop-link-element
            (click)="sendAnalyticEvent(link.route)"
            (linkActivation)="onActivateLink(index)"
            [attr.data-test]="link.testId"
            [disabled]="!checkPermission(link.disabled)"
            [enableIconTooltip]="menuCollapsed"
            [linkIcon]="link.icon"
            [openInBlank]="link.openInBlank"
            [routePath]="link.route"
            [routerPathParams]="link.routeParams"
            [textKey]="link.name"
            [isExpanded]="!menuCollapsed">
          </eop-link-element>
        </li>
      </ng-container>
    </ul>
  </mat-expansion-panel>
</div>
